import React, {useContext, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import FilterDropdown from "../FilterDropdown.jsx";
import Select from "react-select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faListOl, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import Badge from "../Badge.jsx";
import {FilterContext} from "./DashboardFilterContextProvider.jsx";

function CampaignFilter() {
    let {t} = useTranslation();

    let {
        campaignsPossible,
        campaignsAllowListed, setCampaignsAllowListed,
        campaignSearchFilter, setCampaignSearchFilter,

        sourcesRemoved,
    } = useContext(FilterContext);

    let [selectOpened, setSelectOpened] = useState(false);

    let defaultOptions = useMemo(() => {
        let defaultOptions = [];

        Object.values(campaignsPossible)
            .filter((possibleValue) => {
                return !sourcesRemoved.includes(possibleValue.integrationName);
            }).map((possibleValue) => {
            if (campaignsAllowListed.includes(possibleValue.remoteId)) {
                defaultOptions.push({
                    value: possibleValue.remoteId,
                    label: possibleValue.name ?? possibleValue.campaignName ?? '-',
                    campaign: possibleValue
                });
            }
        });

        return defaultOptions;
    }, [sourcesRemoved, campaignsPossible, campaignsAllowListed, campaignSearchFilter]);

    let possibleAmount = useMemo(() => {
        let possibleAmount = 0;

        Object.values(campaignsPossible)
            .filter((possibleValue) => {
                return !sourcesRemoved.includes(possibleValue.integrationName);
            })
            .map(() => {
                possibleAmount++;
            });

        return possibleAmount;
    }, [sourcesRemoved, campaignsPossible, campaignsAllowListed, campaignSearchFilter]);

    let options = useMemo(
        () => {
            return Object.values(campaignsPossible)
                .filter((possibleValue) => {
                    return !sourcesRemoved.includes(possibleValue.integrationName);
                })
                .map((possibleValue) => {
                    return {
                        value: possibleValue.remoteId,
                        label: possibleValue.name ?? possibleValue.campaignName ?? '-',
                        campaign: possibleValue
                    };
                });
        },
        [sourcesRemoved, campaignsPossible, campaignsAllowListed, campaignSearchFilter],
    );


    // noinspection JSUnresolvedReference,JSValidateTypes
    return (<FilterDropdown
        title={t('filter.campaigns')}
        align={'right'}
        button={<div className={'flex justify-center items-center text-nowrap gap-1'}>
            <FontAwesomeIcon icon={faListOl}/>
            {t('filter.campaigns')}

            {campaignSearchFilter.trim() !== '' && <Badge color={'slate'} className={'flex gap-1'}>
                <FontAwesomeIcon icon={faMagnifyingGlass}/>
                {campaignSearchFilter}
            </Badge>}

            {defaultOptions.length > 0 && <Badge color={'slate'}>
                {defaultOptions.length} / {possibleAmount}
            </Badge>}

        </div>}
        inhibitClosing={selectOpened}
    >
        <div className={'min-w-96'}>
            <input
                value={campaignSearchFilter}
                className={'form-input w-full mb-2'}
                onChange={event => setCampaignSearchFilter(event.target.value)}
            />

            <Select
                isMulti
                options={options}
                value={defaultOptions}
                menuPortalTarget={document.body}
                menuPosition='fixed'
                noOptionsMessage={() => t('filter.no-campaigns-found')}
                onMenuOpen={() => setSelectOpened(true)}
                onMenuClose={() => setTimeout(() => setSelectOpened(false), 100)}
                onChange={(val) => setCampaignsAllowListed(val.map((obj) => obj.value))}
                className={'datixo_select_container'}
                classNamePrefix={'datixo_select'}
            />
        </div>
    </FilterDropdown>);
}

export default CampaignFilter;
